import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { earningsEffects } from './slice';

import EarningsTable from './components/Table';
import QuarterNavigation from './components/QuarterNavigation';
import SectorSearch from './components/SectorSearch';
import SymbolSearch from './components/SymbolSearch';

import {
  SBody,
  SBodyWrapperTop,
  SContainer,
  SearchWrapper,
  SHeader,
} from './styled';

const Earnings = () => {
  const dispatch = useDispatch();
  const [screenWidth, setScreenWidth] = useState<number>(0);

  useEffect(() => {
    dispatch(earningsEffects.getScreenerUniverse());
    dispatch(
      earningsEffects.getEarnings({
        order: 'desc',
        page: '1',
        sortcol: '4',
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    const getDimension = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', getDimension);
    getDimension();

    return () => window.removeEventListener('resize', getDimension);
  }, []);

  return (
    <SContainer id="fullbox">
      <SHeader id="genhead">
        <div>Quarterly EPS Recap</div>
        {screenWidth <= 720 ? <QuarterNavigation /> : null}
      </SHeader>
      <SBody>
        <SBodyWrapperTop>
          <SearchWrapper>
            <SectorSearch />
            <SymbolSearch />
          </SearchWrapper>
          {screenWidth > 720 ? <QuarterNavigation /> : null}
        </SBodyWrapperTop>
        <EarningsTable screenWidth={screenWidth} />
      </SBody>
    </SContainer>
  );
};

export default Earnings;
